import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ThemeProvider } from '@emotion/react'
import theme from './components/Theme'
import Header from './components/Header/Header'
import Footer from './components/Footer'
import Routes from './components/routing/Routes'
import setAuthToken from './utils/setAuthToken'
import store from './store'
import { LOGOUT } from './actions/types'
import { loadUser } from './actions/auth'
import { ConfirmProvider } from 'material-ui-confirm'
import moment from 'moment'
import 'moment/locale/vi'
// Redux
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import './App.css'
import { Helmet } from 'react-helmet'
import logo from './assets/logo.png'

moment.locale('vi')

const App = () => {
  useEffect(() => {
    // check for token in LS
    if (localStorage.token) {
      setAuthToken(localStorage.token)
    }

    store.dispatch(loadUser())
    // log user out from all tabs if they log out in one tab
    window.addEventListener('storage', () => {
      if (!localStorage.token) store.dispatch({ type: LOGOUT })
    })
  }, [])

  return (
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <ConfirmProvider>
            <Router>
              <div className="page-container">
                <div className="content-wrap">
                  <CssBaseline />
                  <Header />
                  <Helmet>
                    <title>YouSpeak - Connecting English teachers and English learners</title>
                    <link rel='icon' href={logo} />
                    <meta property='og:title' content='Connecting English teachers and English learners' />
                    <meta property="og:type" content="website" />
                    <meta property="og:image" content={logo} />
                    <meta property="og:url" content="http://youspeak.info/index.htm"></meta>
                    <meta property="og:description" content="Connecting English teachers and English learners" />
                    <meta property="og:site_name" content="YouSpeak, Inc." />
                  </Helmet>
                  <Route component={Routes} />
                  <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                </div>
                <Footer />
              </div>
            </Router>
          </ConfirmProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </Provider>
  );
}
export default App
